<template>
    <div>{{ (Value != undefined && Value.trim()) ? Value : "-" }}</div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class GenericTableStringCell extends Vue {
    /** Valeur */
    @Prop({default: () => ''})
    public Value!: string;
}


</script>
<style scoped>

</style>